import axios from "axios";

const apiUrl = process.env.VUE_APP_APIURL;

const state = () => ({
  url: apiUrl,
  apiStatus: "",
  respondentId: "",
  currentMatchup: "",
  currentProject: "",
  currentSequenceOrder: 1,
  currentMatchupOrder: 1,
  quizProgress: 1,
  randomIdealMatchups: "",
  countRandomIdealMatchups: "",
  currentPackage: "",
  publicPackages: "",
});

const getters = {
  getRespondentId: (state) => state.respondentId,

  /***** packages *****/
  getPackage: (state) => state.currentPackage,
  getPublicPackages: (state) => state.publicPackages,
  getPackageProjects: (state) => state.currentPackage.projects,

  getPackageCurrentProjectOrder: (state) => {
    let currentProjectOrder = state.currentPackage.projects.find(
      (project) => project.data.id === state.currentProject.id
    );

    return currentProjectOrder?.order ? currentProjectOrder.order : 0;
  },

  calcPackageLength: (state, getters) => {
    return state.currentPackage?.rewards
      ? getters.getPackageProjects?.length
      : getters.getPackageProjects?.length + 1;
  },

  getPackageProjectsOrderedList: (state) => {
    let OrderedList = [];
    let i = 1;
    state.currentPackage.projects.forEach(function(project) {
      OrderedList.push({ order: i, projectId: project.data.id });
      i++;
    });

    return OrderedList;
  },
  getHighestPackageProjectOrder: (state) => {
    return Math.max.apply(
      Math,
      state.currentPackage.projects.map(function(project) {
        return project.order;
      })
    );
  },
  getPackageProjectSlug: (state) => (id) => {
    return state.currentPackage.projects.find((x) => x.data.id === id).data
      .random_slug;
  },

  getNextPackageId: (state, getters) => {
    if (
      getters.getPackageCurrentProjectOrder ===
      getters.getHighestPackageProjectOrder
    ) {
      return false;
    } else {
      return getters.getPackageProjectsOrderedList.find(
        (x) => x.order === getters.getPackageCurrentProjectOrder + 1
      ).projectId;
    }
  },
  getNextPackageProjectSlug: (state, getters) => {
    if (getters.getNextPackageId) {
      return getters.getPackageProjectSlug(getters.getNextPackageId);
    } else {
      return false;
    }
  },
  /***** matchups *****/

  getCurrentMatchup: (state) => state.currentMatchup,

  getMatchupCardById: (state) => (id) => {
    return state.currentMatchup?.cards.find((x) => x.id === id);
  },

  getCurrentProject: (state) => state.currentProject,
  getCurrentPackage: (state) => state.currentPackage,
  getQuizProgress: (state) => state.quizProgress,
  getImgPath: (state) => `${apiUrl}/uploads/${state.currentProject.id}/images/`,

  /** new order */
  isProjectFinished: (state, getters) => {
    let project = getters.getCurrentProject;

    if (project.sequences) {
      // is it custom order
      if (project.custom_order) {
        // are all sequences finished?
        if (
          getters.getQuizProgress ===
          getters.getCurrentMatchup?.sequence?.sequence_length
        ) {
          return true;
        }
      }
      // it is random order
      else {
        if (getters.getQuizProgress === getters.countRandomIdealMatchups) {
          return true;
        }
      }
    } else {
      if (getters.getQuizProgress === project?.questions_sequence) {
        return true;
      } else {
        return false;
      }
    }
  },

  projectSequences: (state, getters) => {
    return getters.getCurrentProject?.sequences
      ? getters.getCurrentProject?.sequences
      : 0;
  },
  //sequenceMatchups: (state) => state.api.sequenceMatchups,
  currentSequenceOrder: (state, getters) => {
    return getters.getCurrentMatchup?.sequence?.sequence_order
      ? getters.getCurrentMatchup?.sequence?.sequence_order
      : 0;
  },
  currentMatchupOrder: (state) => state.currentMatchupOrder,
  randomIdealMatchups: (state) => state.randomIdealMatchups,
  countRandomIdealMatchups: (state) => state.countRandomIdealMatchups,
};

const mutations = {
  api_request(state) {
    state.apiStatus = "loading";
  },
  api_error(state) {
    state.apiStatus = "error";
  },
  /***** project *****/
  project_success(state, data) {
    state.api_status = "success";
    state.currentProject = data;
  },
  /***** matchups *****/
  matchup_success(state, data) {
    state.api_status = "success";
    state.currentMatchup = data;
  },
  random_ideal_matchups_success(state, data) {
    state.api_status = "success";
    state.randomIdealMatchups = data;
  },
  count_random_ideal(state, data) {
    state.api_status = "success";
    state.countRandomIdealMatchups = data;
  },
  /***** respodents *****/
  respondent_success(state, data) {
    state.api_status = "success";
    state.respondentId = data;
  },

  quizAddProgress(state) {
    state.quizProgress++;
  },
  quizResetProgress(state) {
    state.quizProgress = 1;
  },
  /*****  seqeunces *****/
  addSequenceOrder(state) {
    state.currentSequenceOrder++;
  },
  addMatchupOrder(state) {
    state.currentMatchupOrder++;
  },
  resetMatchupOrder(state) {
    state.currentMatchupOrder = 1;
  },
  quizResetSequence(state) {
    state.currentSequenceOrder = 1;
    state.currentMatchupOrder = 1;
  },
  /*****  random ideal matchups *****/
  remove_matchup(state, matchupIndex) {
    state.randomIdealMatchups.splice(matchupIndex, 1);
  },

  /******** packages */
  package_success(state, data) {
    state.currentPackage = data;
  },
  publicPackages_success(state, data) {
    state.publicPackages = data;
  },
  resetPackageProject(state) {
    state.quizProgress = 1;
    state.randomIdealMatchups = "";
    state.countRandomIdealMatchups = "";
  },
};

const actions = {
  /***** project *****/
  fetchProject({ commit, rootState }, projectSlug) {
    return new Promise((resolve, reject) => {
      commit("api_request");

      axios({
        url: `${apiUrl}/api/${projectSlug}`,
        headers: {
          Authorization: `Bearer ${rootState.login.token}`,
          "Content-Type": "application/json",
        },
        method: "GET",
      })
        .then((resp) => {
          const data = resp.data.data;
          localStorage.setItem("currentProject", data);
          commit("project_success", data);
          resolve(resp);
        })
        .catch((err) => {
          commit("auth_error");
          reject(err);
        });
    });
  },
  /***** matchups *****/

  fetchRandomProjectMatchup({ commit, rootState }, projectSlug) {
    return new Promise((resolve, reject) => {
      commit("api_request");

      axios({
        url: `${apiUrl}/api/${projectSlug}/matchup/random`,
        headers: {
          Authorization: `Bearer ${rootState.login.token}`,
          "Content-Type": "application/json",
        },
        method: "GET",
      })
        .then((resp) => {
          const data = resp.data.data;
          localStorage.setItem("currentMatchup", data);
          commit("matchup_success", data);
          resolve(resp);
        })
        .catch((err) => {
          commit("auth_error");
          reject(err);
        });
    });
  },
  fetchProjectIdealOrderedMatchup({ commit, rootState }, projectSlug) {
    return new Promise((resolve, reject) => {
      commit("api_request");

      axios({
        url: `${apiUrl}/api/${projectSlug}/matchup/ideal?sequence=${rootState.api.currentSequenceOrder}&matchup=${rootState.api.currentMatchupOrder}&random=0`,
        headers: {
          Authorization: `Bearer ${rootState.login.token}`,
          "Content-Type": "application/json",
        },
        method: "GET",
      })
        .then((resp) => {
          const data = resp.data.data;
          localStorage.setItem("currentMatchup", data);
          commit("matchup_success", data);
          resolve(resp);
        })
        .catch((err) => {
          commit("auth_error");
          reject(err);
        });
    });
  },
  /***** random matchups  */
  fetchRandomSequencesMatchups({ commit, rootState }, projectSlug) {
    return new Promise((resolve, reject) => {
      commit("api_request");

      axios({
        url: `${apiUrl}/api/${projectSlug}/ideal/random`,
        headers: {
          Authorization: `Bearer ${rootState.login.token}`,
          "Content-Type": "application/json",
        },
        method: "GET",
      })
        .then((resp) => {
          const data = resp.data.data;
          const count = resp.data.count;
          commit("count_random_ideal", count);
          commit("random_ideal_matchups_success", data);
          resolve(resp);
        })
        .catch((err) => {
          commit("auth_error");
          reject(err);
        });
    });
  },
  fetchProjectIdealRandomMatchup({ commit, state, rootState }, projectSlug) {
    return new Promise((resolve, reject) => {
      const randomIndex = Math.floor(
        Math.random() * state.randomIdealMatchups.length
      );

      let selectedMatchup = state.randomIdealMatchups[randomIndex];

      commit("remove_matchup", randomIndex);

      commit("api_request");

      axios({
        url: `${apiUrl}/api/${projectSlug}/matchup/ideal?sequence=${selectedMatchup.seq}&matchup=${selectedMatchup.match}&random=1`,
        headers: {
          Authorization: `Bearer ${rootState.login.token}`,
          "Content-Type": "application/json",
        },
        method: "GET",
      })
        .then((resp) => {
          const data = resp.data.data;
          localStorage.setItem("currentMatchup", data);
          commit("matchup_success", data);
          resolve(resp);
        })
        .catch((err) => {
          commit("auth_error");
          reject(err);
        });
    });
  },
  /***** project *****/
  fetchPackage({ commit, rootState }, packageSlug) {
    return new Promise((resolve, reject) => {
      commit("api_request");

      axios({
        url: `${apiUrl}/api/package/${packageSlug}`,
        headers: {
          Authorization: `Bearer ${rootState.login.token}`,
          "Content-Type": "application/json",
        },
        method: "GET",
      })
        .then((resp) => {
          const data = resp.data.data;
          localStorage.setItem("currentPackage", data);
          commit("package_success", data);
          resolve(resp);
        })
        .catch((err) => {
          commit("auth_error");
          reject(err);
        });
    });
  },
  fetchPublicPackages({ commit, rootState }) {
    return new Promise((resolve, reject) => {
      commit("api_request");

      axios({
        url: `${apiUrl}/api/packages/public`,
        headers: {
          Authorization: `Bearer ${rootState.login.token}`,
          "Content-Type": "application/json",
        },
        method: "GET",
      })
        .then((resp) => {
          const data = resp.data.data;
          localStorage.setItem("publicPackages", data);
          commit("publicPackages_success", data);
          resolve(resp);
        })
        .catch((err) => {
          commit("api_error");
          reject(err);
        });
    });
  },
};
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
